// /news/:slug — one post; unknown slugs go back to the newsroom.
import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import CtaBand from '../site/CtaBand';
import Seo, { ORGANIZATION, SITE_URL } from '../site/Seo';
import { POSTS, formatPostDate, postBySlug } from './posts';
import './news.css';

const NewsPost = () => {
  const { slug } = useParams();
  const post = postBySlug(slug);
  if (!post) return <Navigate to="/news" replace />;
  const { Body } = post;
  const more = POSTS.filter(p => p.slug !== post.slug).slice(0, 2);

  return (
    <>
      <Seo
        title={`${post.title} | Bumpups.com`}
        description={post.description}
        image={post.cover}
        type="article"
        jsonLd={{
          '@type': 'BlogPosting',
          headline: post.title,
          description: post.description,
          datePublished: post.date,
          image: SITE_URL + post.cover,
          url: `${SITE_URL}/news/${post.slug}`,
          author: ORGANIZATION,
          publisher: ORGANIZATION,
        }}
      />

      <article className="post">
        <header className="mk-container mk-container--narrow post-head">
          <nav className="post-crumbs" aria-label="Breadcrumb">
            <Link to="/news">News</Link> <span aria-hidden="true">/</span> <span>{post.category}</span>
          </nav>
          <h1 className="mk-h1 post-title">{post.title}</h1>
          <p className="nr-meta"><time dateTime={post.date}>{formatPostDate(post.date)}</time></p>
        </header>
        <div className="mk-container post-cover-wrap">
          <img src={post.cover} alt={post.coverAlt} className="post-cover" />
        </div>
        <div className="mk-container mk-container--narrow post-body">
          <Body />
        </div>
      </article>

      {more.length > 0 && (
        <section className="mk-section mk-section--tight">
          <div className="mk-container mk-container--narrow">
            <h2 className="mk-h3 nr-more-title">More news</h2>
            <div className="nr-more">
              {more.map(p => (
                <Link key={p.slug} to={`/news/${p.slug}`} className="mk-card nr-more-item">
                  <img src={p.cover} alt="" loading="lazy" />
                  <span>
                    <span className="nr-meta">{p.category} · {formatPostDate(p.date)}</span>
                    <span className="nr-more-name">{p.title}</span>
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}

      <CtaBand />
    </>
  );
};

export default NewsPost;
